/* js/toolTip.js */

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})